"use strict";
import { Action } from "../actions";
export default function selectComponentReducer(selected = null, action) {
  switch (action.type) {
    case Action.SELECT_COMPONENT: {
      const { guid, views } = action;
      if (guid) {
        return views[guid];
      }
      return null;
    }
    case Action.SELECT_HOVERED_COMPONENT: {
      const { hover, views } = action;
      if (hover.viewID) {
        return views[hover.viewID];
      }
      return null;
    }
    case Action.UNSELECT_COMPONENT: {
      if (action.selected.guid === action.guid) {
        return null;
      }
      return selected;
    }
    default:
      return selected;
  }
}
